import {
  listEditionResourcesByTag,
  ListEditionResourcesByTagRequestParams,
} from "@/requests/libraries/list-edition-resources-by-tag";
import { useQuery } from "@tanstack/react-query";

export const useListEditionResourcesByTag = (
  variables: ListEditionResourcesByTagRequestParams,
) => {
  return useQuery({
    queryKey: ["editions", "resources", "tag"],
    queryFn: () => listEditionResourcesByTag(variables),
    enabled:
      !!variables.editionId && !!variables.resourceLibraryId && !!variables.tag,
  });
};
